interface NotifyMeLeadData {
  name: string;
  email: string;
  city: string;
  state: string;
}

export function buildNotifyMeLeadPayload(
  data: NotifyMeLeadData,
  extras?: Record<string, unknown>,
) {
  return {
    termo_aceito: true,
    nome: data.name,
    email: data.email,
    cidade: data.city,
    estado: data.state,
    ...extras,
  };
}
